import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FormHelperText, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
    addBRPortfolioEntity,
    addBRPortfolioEntityAndAddToSubportfolio,
    addExistingEntityToSubportfolio
} from "../../../actions";
import {bbIsObject, bbShortenString, isFunctionComponent} from "../../../util/bbHelpers";
import FormControl from "@material-ui/core/FormControl";


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    // const {targetCustomerId} = props;

    // console.log("Displaying add organization to portfolio form. Customer ID is", targetCustomerId)

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustAddPortfolioEntity} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, selfEntityId, loadingPortfolios, loadingAddBRPortfolioEntity, loadingAddBRPortfolioEntityError} = useSelector(({breachrisk}) => breachrisk);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const dispatch = useDispatch();

    const subportfolios = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].portfolios ? portfolios[customerIdToUse].portfolios : null;
    const numSubportfolios = subportfolios && bbIsObject(subportfolios) && Object.keys(subportfolios).length;

    const subportfolioMenuItems = subportfolios ? Object.values(subportfolios) : null;
    if (subportfolioMenuItems) {
        subportfolioMenuItems.sort(function(a, b) {
            const textA = a.name.toUpperCase();
            const textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
    }

    const [organizationName, setOrganizationName] = useState(null);
    const [website, setWebsite] = useState(null);
    const [subportfolioId, setSubportfolioId] = useState(null);



    const clearForm = () => {
        setOrganizationName("");
        setWebsite("");
        document.getElementById('BRPortfolioAddNewEntityForm').reset();
    }


  useEffect(() => {
    if(didJustAddPortfolioEntity) {
        clearForm();
    }
  }, [dispatch, didJustAddPortfolioEntity]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {

        if(numSubportfolios && subportfolioId){
            //they've included a subportfolio, so add this when adding.
            console.log("Submitting a new entity creation request and will add to subportfolio", "subportfolioId", subportfolioId)
                dispatch(addBRPortfolioEntityAndAddToSubportfolio(
                    customerIdToUse,
                    organizationName,
                    website,
                    subportfolioId
                ));
        }else{
            //create without adding to a subportfolio
            console.log("Submitting a new entity creation request but will not add to a portfolio", "subportfolioId", subportfolioId)

            dispatch(addBRPortfolioEntity({
                organizationName: organizationName,
                website: website,
                customerId: customerInView,
            }));
        }



    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">

            <form id={"BRPortfolioAddNewEntityForm"} className={classes.root}>

                <h3>Organization Information</h3>
                <TextField
                    label={<IntlMessages id="appModule.BRPortfolioAddNewEntityForm.organization_name"/>}
                    // fullWidth
                    id="organization_name"
                    name="organizationName"
                    required
                    error={!!errors.organizationName}
                    onChange={(event) => setOrganizationName(event.target.value)}
                    defaultValue={organizationName}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.organizationName?.message}
                />
                <br/>
                <TextField
                    label={<IntlMessages id="appModule.BRPortfolioAddNewEntityForm.website"/>}
                    // fullWidth
                    id="website"
                    name="website"
                    required
                    error={!!errors.website}
                    onChange={(event) => setWebsite(event.target.value)}
                    defaultValue={website}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    inputRef={register({
                        required: "This field is required." ,
                    })}
                    helperText={errors.website?.message}
                />

                {numSubportfolios > 0 &&
                    <>
                        <br/>
                    <FormControl className={classes.formControl}>
                        <InputLabel
                            id="appModule.addEntityToSubportfolio.customer-label"
                            // required
                            error={!!errors.subportfolioId}
                        >
                        <IntlMessages id="appModule.addEntityToSubportfolio.subportfolio"/>
                        </InputLabel>
                        <Select
                            labelId="appModule.addEntityToSubportfolio.subportfolio-label"
                            id="subportfolioId"
                            name="subportfolioId"
                            value={subportfolioId}
                            onChange={(event) => setSubportfolioId(event.target.value)}
                            displayEmpty
                            // className={classes.selectEmpty}
                        >
                            {subportfolioMenuItems &&
                                subportfolioMenuItems.map((subportfolio, i)=>{
                                return  <MenuItem key={i} value={subportfolio.id}>
                            {subportfolio.name} &nbsp;&nbsp; <small><em>{bbShortenString(subportfolio.description, 30, true)}</em></small>
                                </MenuItem>
                            }
                                )
                            }
                        </Select>
                        <FormHelperText
                            error={!!errors.subportfolioId}
                        >
                            {errors.subportfolioId? errors.subportfolioId?.message : "Would you like to add this new company to a portfolio group?"}
                        </FormHelperText>
                    </FormControl>
                        </>
                }



                    <br/>
                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                disabled={!!errors.organizationName || !!errors.website || !!errors.subportfolioId}
                                variant="contained" color="primary"
                                type="submit">
                            <IntlMessages id="form.submit"/>
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form